(function () {
  'use strict';

  if (window.NouvorCartUpsell && window.NouvorCartUpsell.version) {
    window.NouvorCartUpsell.initAll(document);
    return;
  }

  var SELECTOR = '[data-nouvor-cart-upsell]';
  var observeTimer = null;

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector || '.shopify-section');
    return node ? node.innerHTML : '';
  }

  function nativeSubmit(form) {
    HTMLFormElement.prototype.submit.call(form);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function updateCartIconBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;

    var cartBubble = document.getElementById('cart-icon-bubble');
    if (cartBubble) {
      cartBubble.innerHTML = getSectionInnerHTML(sections['cart-icon-bubble']);
    }
  }

  function renderCartSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;

    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState);
    } else {
      updateCartIconBubble(parsedState.sections);
    }
  }

  function publishCartUpdate(form, parsedState) {
    if (!window.publish || !window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) return;

    var variantIdInput = form.querySelector('[name="id"]');

    window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
      source: 'nouvor-cart-upsell',
      cartData: parsedState,
      variantId: variantIdInput ? variantIdInput.value : undefined
    });
  }

  function initUpsell(root) {
    if (!root || root.dataset.ncuReady === 'true') return;

    var forms = root.querySelectorAll('.ncu__form');
    if (!forms.length) return;

    root.dataset.ncuReady = 'true';

    forms.forEach(function (form) {
      if (form.dataset.ncuBound === 'true') return;
      form.dataset.ncuBound = 'true';

      form.addEventListener('submit', async function (event) {
        if (!window.fetch || !window.routes || !window.routes.cart_add_url) return;

        event.preventDefault();

        if (form.dataset.ncuSubmitting === 'true') return;
        form.dataset.ncuSubmitting = 'true';

        var button = form.querySelector('button[type="submit"], button');

        setButtonLoading(button, true);

        try {
          var formData = new FormData(form);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);

          var response = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: formData
          });

          var text = await response.text();
          var parsedState = text ? JSON.parse(text) : {};

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'Cart add failed');
          }

          renderCartSections(parsedState);
          publishCartUpdate(form, parsedState);

          window.setTimeout(function () {
            window.NouvorCartUpsell.initAll(document);
          }, 80);
        } catch (error) {
          nativeSubmit(form);
        } finally {
          form.dataset.ncuSubmitting = 'false';

          if (form.isConnected) {
            setButtonLoading(button, false);
          }
        }
      });
    });
  }

  function initAllUpsells(container) {
    var scope = container || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll(SELECTOR).forEach(initUpsell);
  }

  function observeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.dataset.ncuObserved === 'true' || !window.MutationObserver) return;

    cartDrawer.dataset.ncuObserved = 'true';

    var observer = new MutationObserver(function () {
      if (observeTimer) window.clearTimeout(observeTimer);
      observeTimer = window.setTimeout(function () {
        initAllUpsells(cartDrawer);
      }, 100);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  window.NouvorCartUpsell = {
    version: '2.1.0-smooth-scroll',
    initAll: initAllUpsells
  };

  onReady(function () {
    initAllUpsells(document);
    observeCartDrawer();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllUpsells(event.target);
    observeCartDrawer();
  });

  document.addEventListener('cart:updated', function () {
    initAllUpsells(document);
  });

  document.addEventListener('cart:refresh', function () {
    initAllUpsells(document);
  });
})();
